/**
 * Centralized business / brand configuration for Yessica Cleaning and Painting LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "Yessica Cleaning and Painting LLC",
  shortName: "Yessica Cleaning & Painting",
  legalName: "Yessica Cleaning and Painting LLC",
  owner: "Yessica La O Gomez",
  tagline: "Cleaning, Painting & Pressure Washing in Northern Indiana & Southwest Michigan",
  description:
    "Family-run cleaning and painting company based in Plymouth, IN. Residential and commercial cleaning, interior and exterior painting, cabinets, porches, decks, garages, and pressure washing across Northern Indiana and Southwest Michigan.",

  domain: "yessicacleaningandpainting.com",
  url: "https://yessicacleaningandpainting.com",

  phone: "(305) 748-3036",
  phoneHref: "tel:+13057483036",

  email: "Servicesyessi@gmail.com",
  emailHref: "mailto:Servicesyessi@gmail.com",

  address: {
    street: "11092 Michigan Rd",
    city: "Plymouth",
    state: "IN",
    postalCode: "46563",
    region: "Marshall County",
    serviceRadius: "75 miles",
  },

  hours: {
    summary: "Mon – Fri · 7 AM – 5:30 PM",
    days: "Monday – Friday",
    time: "7:00 AM – 5:30 PM",
  },

  /** Transparent-background circular mark (WebP, ~25KB) used in the UI. */
  logo: "/yessica-logo.webp",
  /** Social preview keeps the flat JPEG — some scrapers render PNG alpha as black. */
  ogImage: "/yessica-logo.jpg",
  favicon: "/yessica-logo.png",

  social: {
    instagram: null,
    facebook: null,
    tiktok: null,
    yelp: null,
  },

  discount: {
    label: "25% Off for Returning Customers",
    short: "25% Loyalty Discount",
    description:
      "Returning customers — and friends they refer to us — save 25% on their next service. Cleaning, painting, or pressure washing.",
  },

  widgets: {
    chatWidgetId: "6a5537e5b9f1b7d47a7c955e",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/XNmbq4qysLRKcCddUhar?widgetId=6a67b76ce3e5a6d2fe8103f0",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/LQWnsLDXx0LccZ6YdH35",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "LQWnsLDXx0LccZ6YdH35",
    formName: "Website Form",
  },

  serviceAreas: [
    "Plymouth, IN",
    "Bremen, IN",
    "Culver, IN",
    "South Bend, IN",
    "Mishawaka, IN",
    "Goshen, IN",
    "La Porte, IN",
    "Valparaiso, IN",
    "Portage, IN",
    "Crown Point, IN",
    "Munster, IN",
    "Dyer, IN",
    "Niles, MI",
    "Three Oaks, MI",
    "Three Rivers, MI",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
